<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>정보마당</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">정보마당</p>
          <ul class="depth">
            <li>
              <router-link to="/map" title="공영주차장">공영주차장</router-link>
            </li>
            <li>
              <router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link>
            </li>
            <li>
              <router-link to="/unpaidinfo" title="미납주차요금">미납주차요금</router-link>
            </li>
            <li>
              <router-link to="/periodinfo" title="주차서비스">주차서비스</router-link>
            </li>
            <li>
              <router-link to="/noticelist" title="정보마당">정보마당</router-link>
            </li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">공지사항</p>
          <ul class="depth">
            <li>
              <router-link to="/noticelist" title="공지사항">공지사항</router-link>
            </li>
            <li>
              <router-link to="/faqview" title="자주묻는질문">자주묻는질문</router-link>
            </li>
            <li>
              <router-link to="/qnalist" title="묻고 답하기">묻고 답하기</router-link>
            </li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">공지사항</h3>
        <article>
          <div class="searchArea">
            <div class="total">
              총<span>{{ noticeCnt }}</span
              >건
            </div>
            <div class="searchBox">
              <div>
                <select id="" v-model="searchCondition" title="검색영역 선택">
                  <option value="1">제목</option>
                  <option value="2">내용</option>
                  <option value="3">제목+내용</option>
                </select>
                <input
                  type="text"
                  title="검색어 입력"
                  v-model="searchKeyword"
                  placeholder="검색어입력"
                  @keyup.enter="search"
                />
              </div>
              <button type="button" @click="search" class="btn dkGray">검색</button>
            </div>
          </div>
          <div class="table vertical-table notice">
            <table>
              <caption>
                공지사항 테이블
              </caption>
              <colgroup>
                <col style="width: 10%" />
                <col style="width: auto" />
                <col style="width: 10%" />
                <col style="width: 10%" />
                <col style="width: 10%" />
                <col style="width: 10%" />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">번호</th>
                  <th scope="col">제목</th>
                  <th scope="col">작성자</th>
                  <th scope="col">등록일</th>
                  <th scope="col">첨부파일</th>
                  <th scope="col">조회수</th>
                </tr>
              </thead>
              <tbody>
                <tr class="nodate" v-if="nodata">
                  <td colspan="6">조회된 데이터가 없습니다.</td>
                </tr>
                <tr v-for="(item, index) in calData" :key="index" @click="view(item.atclId)">
                  <td>{{ listData.length - index - (curPageNum - 1) * dataPerPage }}</td>
                  <td>
                    <p class="title">
                      {{ item.title }}
                    </p>
                  </td>
                  <td>{{ item.regNm }}</td>
                  <td>{{ item.updDttm | ptDateFormat }}</td>
                  <td>
                    <i v-if="item.atchCnt != 0" class="icon file"><span class="hidden">첨부파일</span></i>
                  </td>
                  <td>{{ item.hits }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <v-pagination v-model="curPageNum" :length="numOfPages" />
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import pagination from '../../../util/pagination';

export default {
  data() {
    return {
      listData: [],
      curPageNum: 1,
      dataPerPage: 10,
      nodata: true,
      noticeCnt: 0,
      searchCondition: 1,
      searchKeyword: '',
      cnt: 0,
      temp: '',
    };
  },

  mounted() {
    if (this.$route.query.searchKeyword != undefined) {
      this.searchKeyword = this.$route.query.searchKeyword;
      this.searchCondition = this.$route.query.searchCondition;
      this.curPageNum = Number(this.$route.query.curPageNum);
    }
    this.search();
  },

  methods: {
    async search() {
      if (this.cnt == 0) {
        if (this.searchKeyword != '') {
          this.cnt = 1;
          this.curPageNum = 1;
        }
      } else {
        if (this.searchKeyword != this.temp) {
          this.curPageNum = 1;
          if (this.searchKeyword == '') {
            this.cnt = 0;
          } else {
            this.cnt = 1;
          }
        }
      }
      this.temp = this.searchKeyword;
      const response = await axios('get', '/api/board/notice/list.json', {
        searchCondition: this.searchCondition,
        searchKeyword: this.searchKeyword,
        bbsCd: 'notice',
        recordCountPerPage: this.dataPerPage,
        firstIndex: (this.curPageNum - 1) * this.dataPerPage,
      });
      if (response.data.boardList != undefined) {
        this.noticeCnt = response.data.boardTotalCount;
        this.listData = pagination(response.data.boardList, this.noticeCnt, this.curPageNum, this.dataPerPage);
        this.nodata = this.listData.length > 0 ? false : true;
      }
    },

    view(atclId) {
      this.$router.push({
        path: 'noticeview',
        query: {
          atclId: atclId,
          searchCondition: this.searchCondition,
          searchKeyword: this.searchKeyword,
          curPageNum: this.curPageNum,
        },
      });
    },
  },

  computed: {
    startOffset() {
      return (this.curPageNum - 1) * this.dataPerPage;
    },
    endOffset() {
      return this.startOffset + this.dataPerPage;
    },
    numOfPages() {
      return Math.ceil(this.listData.length / this.dataPerPage);
    },
    calData() {
      if (this.listData.length < 0) {
        return;
      }
      return this.listData.slice(this.startOffset, this.endOffset);
    },
  },
};
</script>
